
import { supabase } from '@/integrations/supabase/client';

// This function adds default prohibited words to the table
export const addDefaultProhibitedWords = async () => {
  const defaultWords = [
    { word: 'racial-slur', category: 'racist' },
    { word: 'hate-speech', category: 'hate-speech' },
    { word: 'extremist-content', category: 'extremism' },
    { word: 'child-exploitation', category: 'illegal-content' }
  ];
  
  try {
    console.log('Adding default prohibited words to database...');
    
    for (const word of defaultWords) {
      try {
        const { error } = await supabase.from('prohibited_words').insert([word]);
        
        if (error && error.code !== '23505') { // 23505 is the error code for duplicate key violation (which is fine)
          console.error(`Error adding default word "${word.word}":`, error);
        }
      } catch (err) {
        console.error(`Error adding default word "${word.word}":`, err);
      }
    }
    
    return { success: true };
  } catch (err) {
    console.error('Error adding default prohibited words:', err);
    return { success: false, error: err };
  }
};

// This function checks if the prohibited_words table exists and is accessible
export const checkProhibitedWordsTable = async () => {
  try {
    const { count, error } = await supabase
      .from('prohibited_words')
      .select('*', { count: 'exact', head: true });
    
    if (error) {
      console.error('Error checking prohibited words table:', error);
      return { exists: false, error };
    }
    
    return { exists: true, count };
  } catch (err) {
    console.error('Error checking prohibited words table:', err);
    return { exists: false, error: err };
  }
};
